module.exports = "/virtual-football-league/img/amblems/left/logos/FakeFulham.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/FakeFulham.png
// module id = 2071
// module chunks = 4